import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/mlogo.png";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdArrowDropdown } from "react-icons/io";
import Logo from "../../assets/Untitled design.png";

const menuItems = [
  {
    name: "Services",
    path: "/services",
    submenu: [
      { name: "Website & Webapp Development", path: "/services/Website-&-Webapp-Development" },
      { name: "Android & iOS App Development", path: "/services/Android-&-iOS-App-Development" },
      { name: "Ui & Ux Design", path: "/services/Ui-&-Ux-Design" },
      { name: "CRM Software", path: "/services/CRM-Software" },
      { name: "POS Software", path: "/services/POS-Software" },
      { name: "Billing Software", path: "/services/Billing-Software" },
    ],
  },
  { name: "Industries", 
     submenu: [
      { name: "Health Care", path: "/industry/healthcare" },
      { name: "Automotive", path: "/industry/automotive" },
      { name: "Banking", path: "/industry/banking" },
      { name: "E-commerce", path : "/industry/e-commerce"},
      { name: "Government", path: "/industry/government" },
      { name: "Infrastructure", path: "/industry/infrastructure" },
      { name: "Real Estate", path: "/industry/realEstate" },
      { name: "Telecom", path: "/industry/telecom" },

    ],
  },
  { 
    name: "Company",
    submenu: [
      { name: "About Us", path: "/about-us" },
      { name: "Carreer", path: "/career" },
      { name: "Partner", path: "/partner" },
      { name: "Trainings", link : "http://learn.techmentee.com/" },

    ],
  },
];

const Navbar = () => {
  // const { isAuthenticated, logout } = useAuth();
  const [openMenu, setOpenMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [isFixed, setIsFixed] = useState(false);
  const path = useLocation()?.pathname;
  const navigate = useNavigate();
  const [isHover , setIsHover] = useState(null);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleSubMenu = (index) => {
    setOpenSubMenu((prevState) => (prevState === index ? null : index));
  };

  return (
    <React.Fragment>
      {/* desktop */}
      <nav className="lg:contents hidden">
        <div className="flex justify-between items-center px-16 py-2 shadow">
          <div onClick={()=>{
            navigate("/");
            window.scrollTo({
              top :0,
              behavior :"smooth"
            })
          }} className="cursor-pointer">
            <img src={Logo} alt="logo" className="w-60" />
          </div>
          <div className="flex gap-10">
            {menuItems.map((item, index) => (
              <div 
              key={index} 
              onMouseEnter={()=> setIsHover(index)}
              onMouseLeave={()=> setIsHover(null)}
              className="relative"
              
              >
                <Link
                  to={item.path || "#"}
                  className="hover:text-primaryDarkOrange font-mono font-semibold transition duration-200 ease-linear flex items-center"
                >
                  {item.name}
                  {item?.submenu && <IoMdArrowDropdown />}
                </Link>
              {item.submenu && isHover === index && (
                <div className="absolute top-full left-0 pt-4 z-50 w-[320px] animate-in fade-in zoom-in-95 duration-300">
                  
                  {/* Small arrow */}
                  <div className="absolute -top-2 left-8 w-4 h-4 bg-white rotate-45 border-l border-t border-gray-100"></div>

                  {/* Dropdown box */}
                  <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white/95 backdrop-blur-md shadow-[0_15px_50px_rgba(0,0,0,0.15)]">

                    {/* Header */}
                    {/* <div className="px-5 py-4 border-b bg-gradient-to-r from-[#7B96BD] to-[#6988b3]">
                      <p className="text-white font-semibold text-sm">
                        Explore {item.name}
                      </p>
                      <p className="text-white/80 text-xs">
                        Discover our solutions and offerings
                      </p>
                    </div> */}

      {/* Menu Items */}
      <div className="p-2">
        {item.submenu.map((subItem, subIndex) =>
          subItem.link ? (
            <div
              key={subIndex}
              onClick={() =>
                window.open(
                  subItem.link,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              className="
              group
              flex items-center
              px-4 py-3
              rounded-xl
              cursor-pointer
              hover:bg-gradient-to-r
              hover:from-[#7B96BD]
              hover:to-[#6988b3]
              transition-all duration-300
              hover:scale-[1.02]
              "
            >
             

              <span className="font-medium text-gray-700 group-hover:text-white">
                {subItem.name}
              </span>
            </div>
          ) : (
            <Link
              key={subIndex}
              to={subItem.path}
              onClick={() => setIsHover(null)}
              className="group flex items-center px-4 py-3 rounded-xl hover:bg-gradient-to-r hover:from-[#7B96BD] hover:to-[#6988b3] transition-all duration-300 hover:scale-[1.02]
              "
            >
              {/* <div
                className="
                w-2 h-2 rounded-full
                bg-[#7B96BD]
                mr-3
                group-hover:bg-white
                "
              /> */}

              <span className="font-medium text-gray-700 group-hover:text-white">
                {subItem.name}
              </span>
            </Link>
          )
        )}
      </div>
    </div>
  </div>
)}
              </div>
            ))}
          </div>
          <div>
            <button
              onClick={() => navigate("/contact-us")}
              className="bg-gradient-to-r from-[#7B96BD] to-[#6988b3] hover:from-[#7795c0] hover:to-[#7298cd] transition duration-200 ease-linear text-white px-8 py-2 rounded"
            >
              Contact Us
            </button>
          </div>
        </div>
      </nav>
      {path === "/" && (
        <nav className="bg-gradient-to-r from-primaryDarkOrange to-primaryExtraLightOrange py-1 text-center text-white lg:flex justify-center hidden">
          <p>Techmentee Inc. "Your Success is our Purpose"</p>
        </nav>
      )}

      {/* mobile */}
      <nav
        className={`px-8 py-4 bg-white lg:hidden flex justify-between items-center ${
          isFixed ? "fixed top-0 left-0 right-0 z-50" : ""
        }`}
      >
        <div>
          {/* Small screens */}
          <img src={logo} alt="small logo" className="w-12 block md:hidden" />

          {/* Medium screens */}
          <img src={Logo} alt="large logo" className="w-60 hidden md:block" />
        </div>

        <button
          onClick={() => setOpenMenu(!openMenu)}
          className="focus:outline-none bg-primaryLightOrange rounded-full p-2"
        >
          <GiHamburgerMenu size={25} color="white" />
        </button>
      </nav>

      <div
        className={`transition-transform duration-300 ease-in-out transform ${
          openMenu ? "translate-x-0" : "translate-x-full"
        } fixed top-0 right-0 h-full w-[70%] bg-gray-200 border z-50 shadow-2xl`}
      >
        <div className="flex items-center justify-between py-4 px-10 border-b">
          <div>
            {/* Small screens */}
            <img src={logo} alt="small logo" className="w-10 block md:hidden" />

            {/* Medium screens */}
            <img src={Logo} alt="large logo" className="w-40 hidden md:block" />
          </div>
          <button
            onClick={() => setOpenMenu(!openMenu)}
            className="focus:outline-none"
          >
            Close
          </button>
        </div>

        <div className="flex flex-col py-4 px-10 space-y-4">
          {menuItems.map((item, index) => (
            <div key={index}>
              <Link
                to={item?.path}
                onClick={() => {
                  !item?.submenu && setOpenMenu(false);
                  item.submenu && toggleSubMenu(index);
                }}
                className="hover:text-primaryDarkOrange transition duration-200 ease-linear text-xl flex items-center"
              >
                {item.name}
                {item?.submenu && <IoMdArrowDropdown />}
              </Link>
              {item.submenu && (
                <div
                  className={`mt-2 bg-white shadow-md rounded-md transition-all duration-300 ease-in-out transform ${
                    openSubMenu === index
                      ? "opacity-100 max-h-screen translate-y-0"
                      : "opacity-0 max-h-0 translate-y-4"
                  } overflow-hidden`}
                >
                  {item.submenu.map((subItem, subIndex) => (
                    <Link
                      key={subIndex}
                      to={subItem.path}
                      className="block px-4 py-2 hover:bg-gray-100 transition duration-200 ease-linear"
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <button
            onClick={() => {
              setOpenMenu(false);
              navigate("/contact-us");
            }}
            className="bg-gradient-to-r from-primaryDarkOrange to-primaryLightOrange text-white px-4 py-2 rounded"
          >
            Contact Us
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Navbar;


// import { useState, useRef, useEffect } from "react";
// import { IoMdArrowDropdown } from "react-icons/io";

// const menuItems = [
//   {
//     name: "Products",
//     path: "/products",
//     submenu: [
//       { name: "Analytics Dashboard", path: "/products/analytics" },
//       { name: "AI Insights", path: "/products/ai" },
//       { name: "Data Studio", path: "/products/studio" },
//     ],
//   },
//   {
//     name: "Solutions",
//     path: "/solutions",
//     submenu: [
//       { name: "Enterprise", path: "/solutions/enterprise" },
//       { name: "Documentation", link: "https://docs.example.com" },
//       { name: "Case Studies", path: "/solutions/cases" },
//     ],
//   },
//   {
//     name: "Pricing",
//     path: "/pricing",
//   },
//   {
//     name: "Resources",
//     path: "/resources",
//     submenu: [
//       { name: "Blog", path: "/resources/blog" },
//       { name: "Community", link: "https://community.example.com" },
//       { name: "API Reference", link: "https://api.example.com" },
//     ],
//   },
//   {
//     name: "Company",
//     path: "/company",
//     submenu: [
//       { name: "About Us", path: "/company/about" },
//       { name: "Careers", path: "/company/careers" },
//       { name: "Press", path: "/company/press" },
//     ],
//   },
// ];

// function NavLink({ to, children, className, onClick }) {
//   if (onClick) {
//     return (
//       <span className={className} onClick={onClick} style={{ cursor: "pointer" }}>
//         {children}
//       </span>
//     );
//   }
//   return (
//     <a href={to} className={className}>
//       {children}
//     </a>
//   );
// }

// export default function NavMenu() {
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [animatingOut, setAnimatingOut] = useState(null);
//   const timeoutRef = useRef(null);

//   const handleEnter = (index) => {
//     clearTimeout(timeoutRef.current);
//     setAnimatingOut(null);
//     setActiveIndex(index);
//   };

//   const handleLeave = (index) => {
//     setAnimatingOut(index);
//     timeoutRef.current = setTimeout(() => {
//       setActiveIndex(null);
//       setAnimatingOut(null);
//     }, 200);
//   };

//   useEffect(() => () => clearTimeout(timeoutRef.current), []);

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex flex-col items-center pt-10 font-sans">
//       {/* Nav bar */}
//       <nav className="relative z-50 flex items-center gap-1 px-3 py-2 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
//         {/* Logo mark */}
//         <div className="mr-4 px-3 py-1.5 flex items-center gap-2">
//           <div className="w-6 h-6 rounded-md bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center">
//             <span className="text-white text-xs font-bold">N</span>
//           </div>
//           <span className="text-white/90 font-semibold tracking-tight text-sm">Nexus</span>
//         </div>

//         <div className="w-px h-5 bg-white/10 mr-2" />

//         {menuItems.map((item, index) => (
//           <div
//             key={index}
//             className="relative"
//             onMouseEnter={() => handleEnter(index)}
//             onMouseLeave={() => handleLeave(index)}
//           >
//             {/* Trigger */}
//             <NavLink
//               to={item.path || "#"}
//               className={`
//                 relative flex items-center gap-0.5 px-3.5 py-2 rounded-xl text-sm font-medium
//                 transition-all duration-150 select-none group
//                 ${activeIndex === index
//                   ? "text-white bg-white/10"
//                   : "text-white/60 hover:text-white hover:bg-white/8"
//                 }
//               `}
//             >
//               <span>{item.name}</span>
//               {item.submenu && (
//                 <span
//                   className={`transition-transform duration-200 text-lg leading-none ${
//                     activeIndex === index ? "rotate-180 text-violet-400" : "text-white/40"
//                   }`}
//                 >
//                   <IoMdArrowDropdown />
//                 </span>
//               )}
//               {/* Active underline glow */}
//               {activeIndex === index && (
//                 <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-violet-400 blur-[2px]" />
//               )}
//             </NavLink>

//             {/* Dropdown panel */}
//             {item.submenu && activeIndex === index && (
//               <div
//                 className={`
//                   absolute top-full left-1/2 -translate-x-1/2 mt-2 w-56
//                   rounded-2xl border border-white/10 bg-slate-900/95 backdrop-blur-2xl
//                   shadow-[0_20px_60px_rgba(0,0,0,0.6)]
//                   overflow-hidden
//                   ${animatingOut === index ? "animate-fade-out" : "animate-dropdown-in"}
//                 `}
//               >
//                 {/* Top accent */}
//                 <div className="h-px w-full bg-gradient-to-r from-transparent via-violet-500/60 to-transparent" />

//                 <div className="p-1.5">
//                   {item.submenu.map((subItem, subIndex) => (
//                     <NavLink
//                       key={subIndex}
//                       to={subItem.path || "#"}
//                       onClick={
//                         subItem.link
//                           ? () => window.open(subItem.link, "_blank", "noopener,noreferrer")
//                           : undefined
//                       }
//                       className="
//                         group flex items-center justify-between px-3.5 py-2.5 rounded-xl
//                         text-sm text-white/60 hover:text-white hover:bg-white/8
//                         transition-all duration-150 cursor-pointer
//                       "
//                     >
//                       <span>{subItem.name}</span>
//                       <span className="opacity-0 group-hover:opacity-100 translate-x-0 group-hover:translate-x-0.5 transition-all duration-150 text-violet-400 text-xs">
//                         {subItem.link ? "↗" : "→"}
//                       </span>
//                     </NavLink>
//                   ))}
//                 </div>

//                 {/* Bottom accent */}
//                 <div className="h-px w-full bg-gradient-to-r from-transparent via-white/5 to-transparent" />
//               </div>
//             )}
//           </div>
//         ))}

//         <div className="w-px h-5 bg-white/10 ml-2 mr-1" />

//         {/* CTA Button */}
//         <button className="ml-1 px-4 py-2 rounded-xl text-sm font-semibold bg-gradient-to-b from-violet-500 to-violet-700 text-white shadow-[0_2px_12px_rgba(124,58,237,0.4)] hover:shadow-[0_4px_20px_rgba(124,58,237,0.6)] hover:from-violet-400 hover:to-violet-600 transition-all duration-200 active:scale-95">
//           Get started
//         </button>
//       </nav>

//       {/* Demo label */}
//       <p className="mt-8 text-white/20 text-xs tracking-widest uppercase font-mono">
//         Hover the menu items
//       </p>

//       {/* Ambient glow */}
//       <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-violet-600/10 blur-[80px] rounded-full pointer-events-none" />

//       <style>{`
//         @keyframes dropdown-in {
//           from { opacity: 0; transform: translateX(-50%) translateY(-6px) scale(0.97); }
//           to   { opacity: 1; transform: translateX(-50%) translateY(0)   scale(1);    }
//         }
//         @keyframes fade-out {
//           from { opacity: 1; transform: translateX(-50%) translateY(0)   scale(1);    }
//           to   { opacity: 0; transform: translateX(-50%) translateY(-4px) scale(0.97); }
//         }
//         .animate-dropdown-in { animation: dropdown-in 0.18s cubic-bezier(0.16,1,0.3,1) forwards; }
//         .animate-fade-out    { animation: fade-out    0.15s ease-in forwards; }
//       `}</style>
//     </div>
//   );
// }